import UAParser from 'ua-parser-js';

export const useIsPWA = () => {
  const parser = new UAParser();

  const isPWA = window.matchMedia('(display-mode: standalone)').matches;

  const os = parser.getOS();
  const iOS = os && os.name?.includes('iOS');
  const isSafari = parser.getBrowser().name?.includes('Safari');
  const iOSSafari = iOS && isSafari;

  return {
    isPWA,
    iOS,
    iOSSafari,
  };
};
